import { useSearchParams } from 'react-router';

import { IFilterBuilder } from '@/shared/filters/filter-builder.interfaces';
import { getFilterMethod } from '@/shared/filters/utils/get-filter-method';

export const useFilter = <T>(
  filterBuilder: IFilterBuilder<T>,
): T | undefined => {
  const [searchParams] = useSearchParams();

  const constructFilter = () => {
    filterBuilder.reset();

    filterBuilder.allowedFilters.forEach((filterKey) => {
      const key = String(filterKey);
      const filterValue = searchParams.get(key);

      if (filterValue) {
        const filterMethod = getFilterMethod(filterValue);

        filterBuilder.applyFilter(filterKey, filterValue, filterMethod);
      }
    });

    return filterBuilder.build();
  };

  return constructFilter();
};
